import eliot from './config.eliot';
import kicklox from './config.kicklox';
import mapo from './config.mapo';
import phm from './config.phm';
import rhco from './config.rhco';
import swim from './config.swim';
import sytria from './config.sytria';

import { Config } from './types';

type Tenant = 'eliot' | 'kicklox' | 'mapo' | 'phm' | 'rhco' | 'swim' | 'sytria';

const configs: Record<Tenant, Config> = {
  eliot,
  kicklox,
  mapo,
  phm,
  rhco,
  swim,
  sytria,
};

const tenant = (process.env.REACT_APP_TENANT || 'kicklox') as Tenant;

const config = configs[tenant] || configs.kicklox;

export default config;
